import * as React from 'react';
import { EDomain } from '../../base/types';
import SideStory from '../../components/SideStory/SideStory';
import EvaluationExercises from './EvaluationExercises';
import EvaluationHistogram from './EvaluationHistogram';

export interface IDomainEvaluationViewProps {
  selectedDomain: EDomain | null;
  userId?: number;
}

export const DomainEvaluationView: React.FC<IDomainEvaluationViewProps> = ({ selectedDomain, userId }) => {
  return (
    <>
      <EvaluationHistogram domain={selectedDomain} key={`evaluation-results-${selectedDomain}`} userId={userId} />
      <SideStory domain={selectedDomain} />
      <EvaluationExercises domain={selectedDomain} userId={userId} />
    </>
  );
};

export default DomainEvaluationView;
